import React from "react"

export const ResizeMode = {
  CONTAIN: "contain",
  COVER: "cover",
  STRETCH: "fill",
  NONE: "none",
}

const Video = React.forwardRef(
  (
    {
      source,
      style,
      poster,
      controls = true,
      muted,
      paused,
      repeat,
      resizeMode,
      children,
      ...rest
    },
    ref,
  ) => {
    const uri = source?.uri || ""
    const objectFit =
      resizeMode === ResizeMode.CONTAIN
        ? "contain"
        : resizeMode === ResizeMode.COVER
        ? "cover"
        : resizeMode === ResizeMode.STRETCH
        ? "fill"
        : resizeMode === ResizeMode.NONE
        ? "none"
        : "cover"

    return (
      <video
        ref={ref}
        src={uri}
        poster={poster}
        controls={controls}
        muted={muted}
        loop={repeat}
        autoPlay={paused === false}
        style={{ width: "100%", height: "100%", objectFit, ...style }}
        {...rest}
      >
        {children}
      </video>
    )
  },
)

export default Video
